<template>
  <a-modal v-model="visible" :footer="null" :width="420" title="激活展商权益" class="exhibitor">
    <p class="title"><span>请输入激活码</span></p>
    <p class="tip">
      一个激活码仅可使用一次，激活权益后即时生效，有效期90天。
    </p>
    <div class="active-exhibitor">
      <a-input size="large" v-model="value"></a-input>
      <p class="error-tip" v-html="error"></p>
      <p style="text-align:center;">
        <a @click="activeExhibitor">
          提交
          <a-icon type="caret-right" style="transform: scale(0.7);" />
        </a>
      </p>
    </div>
  </a-modal>
</template>
<script>
export default {
  data() {
    return {
      visible: true,
      error: "",
      value: ""
    };
  },
  methods: {
    activeExhibitor() {
      if (this.value.length != 8) {
        return this.$message.error("激活码无效");
      }
      this.$http
        .post("/activationCode", { activationCode: this.value })
        .then(res => {
          if (!!res.error) {
            return this.$message.error(res.errorMsg);
          }
          location.href = location.href;
        })
        .catch(e => {
          this.$message.error(e);
        });
    }
  }
};
</script>
<style lang="scss">
.exhibitor {
  .ant-modal-header {
    padding: 15px 24px;
    background-color: #f3f3f3;
  }
  .ant-modal-body {
    padding: 0;
    .tip {
      padding: 0 20px;
      font-size: 12px;
      text-align: center;
      color: #999;
    }
    .title {
      margin: 35px 0 25px;
      text-align: center;
      span {
        background: #fff;
        padding: 0 5px;
        position: relative;
        z-index: 1;
        font-size: 17px;
        color: #333;
        font-weight: bold;
        &::before {
          content: " ";
          display: block;
          background: #f1f1f1;
          height: 1px;
          position: absolute;
          top: 10px;
          width: 380px;
          z-index: -1;
          margin: 0 20px;
        }
      }
    }
    .active-exhibitor {
      padding: 0 20px 5px;
      & /deep/ .ant-input {
        border-radius: 0;
        text-align: center;
        font-size: 24px;
        font-weight: bold;
        color: #333;
        letter-spacing: 10px;
      }
      .error-tip {
        color: red;
        margin: 10px 0;
      }
    }
  }
}
</style>